export default __webpack_public_path__ + "static/media/12.2c499f22.jpg";